/* Navura mobile product interactions and product information accordions. */
(function () {
  function isMobileLayout() {
    return !!(window.matchMedia && window.matchMedia("(max-width: 749px)").matches);
  }

  function forceCloseProductModal(modal) {
    if (!modal) return;

    var closedByNativeModal = false;
    try {
      if (typeof modal.hide === "function") {
        modal.hide();
        closedByNativeModal = !modal.hasAttribute("open");
      }
    } catch (error) {
      closedByNativeModal = false;
    }

    if (!closedByNativeModal || modal.hasAttribute("open")) {
      modal.removeAttribute("open");
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }

    if (!document.querySelector("product-modal[open]")) {
      document.body.classList.remove("overflow-hidden");
    }

    var opener = modal.openedBy;
    if (opener && typeof opener.focus === "function") {
      try {
        opener.focus({ preventScroll: true });
      } catch (error) {
        opener.focus();
      }
    }
  }

  function closeProductModal(event) {
    var target = event.target;
    var closeButton = target && target.closest
      ? target.closest("product-modal .product-media-modal__toggle")
      : null;

    if (!closeButton) return;

    var modal = closeButton.closest("product-modal");
    if (!modal) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    forceCloseProductModal(modal);
  }

  function closeProductModalWithEscape(event) {
    if (event.key !== "Escape") return;

    var modal = document.querySelector("product-modal[open]");
    if (!modal) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    forceCloseProductModal(modal);
  }

  function resolveFbtProductLink(link) {
    if (!link || !link.getAttribute) return "";

    var existingHref = link.getAttribute("href");
    if (existingHref) return existingHref;

    var quickViewId = link.getAttribute("qv-id") || "";
    var productIdMatch = quickViewId.match(/-p(\d+)-quick-view$/);
    if (!productIdMatch) return "";

    var productId = productIdMatch[1];
    var modals = document.querySelectorAll(".fether .ft-bundle-cv-modal");
    for (var i = 0; i < modals.length; i += 1) {
      var modal = modals[i];
      if (!modal.id || modal.id.indexOf("-p" + productId) === -1) continue;

      var productLink = modal.querySelector("a[href*='/products/']");
      var href = productLink && productLink.getAttribute("href");
      if (!href) continue;

      link.setAttribute("href", href);
      link.setAttribute("data-navura-fbt-link", "true");
      link.setAttribute("touch-action", "manipulation");
      return href;
    }

    return "";
  }

  function prepareFbtLink(event) {
    if (!isMobileLayout()) return;

    var target = event.target;
    var link = target && target.closest ? target.closest(".fether [qv-id]") : null;
    if (link) resolveFbtProductLink(link);
  }

  function fallbackFbtNavigation(event) {
    if (!isMobileLayout()) return;

    var target = event.target;
    var link = target && target.closest ? target.closest(".fether [qv-id]") : null;
    if (!link) return;

    var href = resolveFbtProductLink(link);
    if (!href || !event.defaultPrevented) return;

    window.setTimeout(function () {
      var quickViewIsOpen = document.querySelector(".fether .ft-modal-show, .fether .ft-modal[open]");
      if (!quickViewIsOpen) window.location.assign(href);
    }, 650);
  }

  function initAccordions() {
    document.querySelectorAll(".navura-info-item").forEach(function (accordion) {
      var summary = accordion.querySelector("summary");
      var content = accordion.querySelector(".navura-info-content");
      if (!summary || !content) return;

      if (accordion.open) content.style.maxHeight = content.scrollHeight + "px";

      summary.addEventListener("click", function (event) {
        event.preventDefault();

        if (accordion.open) {
          content.style.maxHeight = content.scrollHeight + "px";
          requestAnimationFrame(function () {
            content.style.maxHeight = "0px";
          });

          content.addEventListener("transitionend", function closeOnce() {
            accordion.open = false;
            content.removeEventListener("transitionend", closeOnce);
          });
        } else {
          accordion.open = true;
          requestAnimationFrame(function () {
            content.style.maxHeight = content.scrollHeight + "px";
          });
        }
      });
    });
  }

  if (!window.__navuraProductInteractionsInstalled) {
    window.__navuraProductInteractionsInstalled = true;
    document.addEventListener("click", closeProductModal, true);
    document.addEventListener("keydown", closeProductModalWithEscape, true);
    document.addEventListener("pointerdown", prepareFbtLink, true);
    document.addEventListener("click", fallbackFbtNavigation);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAccordions, { once: true });
  } else {
    initAccordions();
  }
})();
